import type { Dispatch } from 'redux';
import actions from './actions';
import { cartSelectors } from '../cart';
import {
  setShippingMethod,
  refreshShippingQuotes,
} from '../../apis/vistacartApi';
import type { RootState } from '../../types';
import { noticeError } from '../../apis/newRelicTracking';

const saveSelectedShippingOption =
  (selectedShippingOptionId: string) =>
  async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(actions.SHIPPING_OPTIONS_SET_START(selectedShippingOptionId));
    const { cart } = getState();
    const shopperId = cartSelectors.selectShopperId(cart);
    const tenant = cartSelectors.selectTenant(cart);

    try {
      await setShippingMethod(tenant, shopperId, selectedShippingOptionId);
      dispatch(actions.SHIPPING_OPTIONS_SET_SUCCESS());
    } catch (error: any) {
      dispatch(actions.SHIPPING_OPTIONS_SET_FAIL(error));
    }
  };

const refreshShippingOptions =
  () => async (dispatch: Dispatch, getState: () => RootState) => {
    dispatch(actions.SHIPPING_OPTIONS_REFRESH_START());
    const { cart } = getState();
    const shopperId = cartSelectors.selectShopperId(cart);
    const tenant = cartSelectors.selectTenant(cart);
    try {
      await refreshShippingQuotes(tenant, shopperId);
      dispatch(actions.SHIPPING_OPTIONS_REFRESH_SUCCESS());
    } catch (error: any) {
      if (!error.nrReporterSource) {
        noticeError({ error, shopperId, tenant });
      }
      dispatch(actions.SHIPPING_OPTIONS_REFRESH_FAIL());
    }
  };

export default {
  saveSelectedShippingOption,
  refreshShippingOptions,
};
